(function () {
	angular
		.module('trackeye')
		.factory('Features', _FeaturesFactory);

	_FeaturesFactory.$inject = [];

	function _FeaturesFactory() {
		function Features(device) {
			this.model = undefined;
			this.description = undefined;
			this.featuremask = undefined;
			this.sut_protocol = undefined;
			this.batt_icon_enable = undefined;
			this.batt_state_icon_enable = undefined;
			this.batt_medium_value = undefined;
			this.batt_low_value = undefined;
			this.dist_sensor = undefined;
			this.dist_sensor_min_volt = undefined;
			this.dist_sensor_max_volt = undefined;
			this.dist_sensor_min_dist = undefined;
			this.dist_sensor_max_dist = undefined;
			this.dist_sensor_measure_unit = undefined;
			this.dist_sensor_alarm_point_min = undefined;
			this.dist_sensor_alarm_point_max = undefined;
			this.dist_sensor_max_dist_change = undefined;
			this._device = device;
			this.batt_hyst = 50;
		}

		Features.prototype.populate = function (data) {
			for (var key in data) {
				if (this.hasOwnProperty(key)) {
					this[key] = data[key];
				}
			}
		};

		Features.prototype.hasInput1 = function () {
			return this.isFeatureBitSet(0);
		};

		Features.prototype.hasInput2 = function () {
			return this.isFeatureBitSet(1);
		};

		Features.prototype.hasInput3 = function () {
			return this.isFeatureBitSet(2);
		};

		Features.prototype.hasInput4 = function () {
			return this.isFeatureBitSet(3);
		};

		Features.prototype.hasOutput1 = function () {
			return this.isFeatureBitSet(4);
		};

		Features.prototype.hasOutput2 = function () {
			return this.isFeatureBitSet(5);
		};

		Features.prototype.hasAutoStartCharge0 = function () {
			// Must be inverted according to specification
			return !this.isFeatureBitSet(6);
		};

		Features.prototype.hasSpeakFunctions = function () {
			return this.isFeatureBitSet(7);
		};

		Features.prototype.hasAutomaticGeofence = function () {
			return this.isFeatureBitSet(8);
		};

		Features.prototype.hasIdle = function () {
			return this.isFeatureBitSet(9);
		};

		Features.prototype.has1WireSupport = function () {
			return this.isFeatureBitSet(10);
		};

		Features.prototype.hasOptStatusSupport = function () {
			return this.isFeatureBitSet(11);
		};

		Features.prototype.has1WireHumidity = function () {
			return this.isFeatureBitSet(12);
		};

		Features.prototype.hasGData = function () {
			return this.isFeatureBitSet(13);
		};

		Features.prototype.hasFlexpadFTNavgiatorSupport = function () {
			return this.isFeatureBitSet(14);
		};

		Features.prototype.hasTagSupport = function () {
			return this.isFeatureBitSet(15);
		};

		Features.prototype.hasMoveGLimit = function () {
			return this.isFeatureBitSet(16);
		};

		Features.prototype.hasRs232Support = function () {
			return this.isFeatureBitSet(17);
		};

		Features.prototype.hasMaxSpeed = function () {
			return this.isFeatureBitSet(18);
		};

		Features.prototype.hasCanBus = function () {
			return this.isFeatureBitSet(19);
		};

		Features.prototype.hasButton1 = function () {
			return this.isFeatureBitSet(20);
		};

		Features.prototype.hasButton2 = function () {
			return this.isFeatureBitSet(21);
		};

		Features.prototype.hasButton3 = function () {
			return this.isFeatureBitSet(22);
		};

		Features.prototype.hasButton4 = function () {
			return this.isFeatureBitSet(23);
		};

		Features.prototype.hasDeadman = function () {
			return this.isFeatureBitSet(24);
		};

		Features.prototype.hasMovement = function () {
			return this.isFeatureBitSet(25);
		};

		Features.prototype.hasStealth = function () {
			return this.isFeatureBitSet(26);
		};

		Features.prototype.hasGeofenceInDevice = function () {
			return this.isFeatureBitSet(27);
		};

		Features.prototype.hasGps = function () {
			return this.isFeatureBitSet(28);
		};

		Features.prototype.hasGSensor = function () {
			return this.isFeatureBitSet(29);
		};

		Features.prototype.hasLightSensor = function () {
			return this.isFeatureBitSet(30);
		};

		Features.prototype.hasTamper = function () {
			return this.isFeatureBitSet(31);
		};

		Features.prototype.hasOwnHourReportSupport = function () {
			return this.isFeatureBitSet(32);
		};

		Features.prototype.hasTemperatureSensor = function () {
			return this.isFeatureBitSet(33);
		};

		Features.prototype.hasDistanceMeter = function () {
			return this.isFeatureBitSet(34);
		};

		Features.prototype.hasBeacon = function () {
			return this.isFeatureBitSet(35);
		};

		Features.prototype.hasEchoTagSupport = function () {
			return this.isFeatureBitSet(36);
		};

		Features.prototype.hasAnalogTankgauge = function () {
			return this.isFeatureBitSet(37);
		};

		Features.prototype.isCapture = function () {
			return this.isFeatureBitSet(38);
		};

		Features.prototype.isRapid = function () {
			return this.isFeatureBitSet(39);
		};

		// Not part of the feature mask
		Features.prototype.isPoliceRapid = function () {
			return this.isRapid() && (this._device.getSubscription() === 21);
		};

		Features.prototype.isRock = function () {
			return this.isFeatureBitSet(40)
		};

		Features.prototype.isSonic = function () {
			return this.hasDistanceMeter()
		};

		Features.prototype.isTamper = function () {
			return this.hasTamper()
		};

		Features.prototype.isPower = function () {
			return this.isFeatureBitSet(41)
		}

		Features.prototype.useBatteryIcon = function () {
			return !!parseInt(this.batt_icon_enable, 10);
		};

		Features.prototype.useBatteryStateIcon = function () {
			return !!parseInt(this.batt_state_icon_enable, 10);
		};

		Features.prototype.getBatteryHysteresis = function() {
			return parseInt(this.batt_hyst, 10);
		};

		Features.prototype.getBatteryMediumValue = function (hyst) {
			var batt_value = parseInt(this.batt_medium_value, 10),
				hysteresis = this.getBatteryHysteresis();

			switch (hyst) {
				case 'high':
					return batt_value + hysteresis;
				case 'low':
					return batt_value - hysteresis;
				default:
					return batt_value;
			}
		};

		Features.prototype.getBatteryLowValue = function (hyst) {
			var batt_value = parseInt(this.batt_low_value, 10),
				hysteresis = this.getBatteryHysteresis();

			switch (hyst) {
				case 'high':
					return batt_value + hysteresis;
				case 'low':
					return batt_value - hysteresis;
				default:
					return batt_value;
			}
		};

		Features.prototype.getDistanceMin = function () {
			return parseInt(this.dist_sensor_min_dist, 10);
		};

		Features.prototype.getDistanceMax = function () {
			return parseInt(this.dist_sensor_max_dist, 10);
		};

		Features.prototype.getDistanceMinVoltage = function () {
			return parseInt(this.dist_sensor_min_volt, 10);
		};

		Features.prototype.getDistanceMaxVoltage = function () {
			return parseInt(this.dist_sensor_max_volt, 10);
		};

		Features.prototype.getDistanceUnit = function () {
			return this.dist_sensor_measure_unit;
		};

		/**
		 * Calculate distance from analogue value
		 * 
		 * Sensor:
		 * Vcc/1024 per cm. distance, Vcc is 3V = 0.00293 V/cm
		 * 
		 * Lommy device:
		 * reported value / (voltage divider in device is dist_sensor_max_volt/2490) = mV
		 * 
		 * example:
		 * 16385 / (60090 / 2490) = 978.95mV
		 * distance = 978.95 / 1000 / 0.00293 = 334cm
		 * 
		 * Formula: 
		 * distCm = ( ( analog_value / (maxDistVolt / 2490) ) / 1000 / Vcm )
		 * @param {number} analog_value
		 * @returns {number}
		 */
		Features.prototype.calcDistance = function (analog_value) {
			var Vcm = (3 / 1024),
				voltage_divider = (this.getDistanceMaxVoltage() / 2490),
				measured_mv = ( parseInt(analog_value) / voltage_divider ),
				distance = (measured_mv / 1000 / Vcm);

			return Math.round(distance);
		};

		/**
		 * Calculate analogue value from distance
		 * 
		 * Formula:
		 * analog_value = distCm * Vcm * 1000 * (maxDistVolt / 2490)
		 * 
		 * @param {number} distance_cm
		 * @returns {number}
		 */
		Features.prototype.calcDistanceAna = function (distance_cm) {
			var Vcm = 3 / 1024,
				voltage_divider = (this.getDistanceMaxVoltage() / 2490),
				calculated_mv = distance_cm * Vcm * 1000,
				analog_value = calculated_mv * voltage_divider;

			return Math.round(analog_value);
		};

		/**
		 * Checks against the featuremask if the passed bit is set.
		 * This supports 64-bit integers!
		 *
		 * Explanation https://stackoverflow.com/questions/337355/javascript-bitwise-shift-of-long-long-number
		 *
		 * @param  {number} [bit=2] - Bit of featuremask
		 * @return {Boolean}
		 */
		Features.prototype.isFeatureBitSet = function (bit) {
			return !!(Math.floor(this.featuremask / Math.pow(2, bit)) & (1 << 0));
		};

		return Features;
	}
})();